module.exports = __webpack_public_path__ + "static/img/4121_phase_function_Paper_Points.e4ef748.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4121_phase_function_Paper_Points.png
// module id = 5V00
// module chunks = 0